import { color } from '@core-ds/primitives';

export default {
   black: `${color.black}`,
   white: `${color.white}`,
   rose: {
      50: `${color.rose[50]}`,
      100: `${color.rose[100]}`,
      200: `${color.rose[200]}`,
      300: `${color.rose[300]}`,
      400: `${color.rose[400]}`,
      500: `${color.rose[500]}`,
      600: `${color.rose[600]}`,
      700: `${color.rose[700]}`,
      800: `${color.rose[800]}`,
      900: `${color.rose[900]}`,
   },
   pink: {
      50: `${color.pink[50]}`,
      100: `${color.pink[100]}`,
      200: `${color.pink[200]}`,
      300: `${color.pink[300]}`,
      400: `${color.pink[400]}`,
      500: `${color.pink[500]}`,
      600: `${color.pink[600]}`,
      700: `${color.pink[700]}`,
      800: `${color.pink[800]}`,
      900: `${color.pink[900]}`,
   },
   fuchsia: {
      50: `${color.fuchsia[50]}`,
      100: `${color.fuchsia[100]}`,
      200: `${color.fuchsia[200]}`,
      300: `${color.fuchsia[300]}`,
      400: `${color.fuchsia[400]}`,
      500: `${color.fuchsia[500]}`,
      600: `${color.fuchsia[600]}`,
      700: `${color.fuchsia[700]}`,
      800: `${color.fuchsia[800]}`,
      900: `${color.fuchsia[900]}`,
   },
   purple: {
      50: `${color.purple[50]}`,
      100: `${color.purple[100]}`,
      200: `${color.purple[200]}`,
      300: `${color.purple[300]}`,
      400: `${color.purple[400]}`,
      500: `${color.purple[500]}`,
      600: `${color.purple[600]}`,
      700: `${color.purple[700]}`,
      800: `${color.purple[800]}`,
      900: `${color.purple[900]}`,
   },
   violet: {
      50: `${color.violet[50]}`,
      100: `${color.violet[100]}`,
      200: `${color.violet[200]}`,
      300: `${color.violet[300]}`,
      400: `${color.violet[400]}`,
      500: `${color.violet[500]}`,
      600: `${color.violet[600]}`,
      700: `${color.violet[700]}`,
      800: `${color.violet[800]}`,
      900: `${color.violet[900]}`,
   },
   indigo: {
      50: `${color.indigo[50]}`,
      100: `${color.indigo[100]}`,
      200: `${color.indigo[200]}`,
      300: `${color.indigo[300]}`,
      400: `${color.indigo[400]}`,
      500: `${color.indigo[500]}`,
      600: `${color.indigo[600]}`,
      700: `${color.indigo[700]}`,
      800: `${color.indigo[800]}`,
      900: `${color.indigo[900]}`,
   },
   blue: {
      50: `${color.blue[50]}`,
      100: `${color.blue[100]}`,
      200: `${color.blue[200]}`,
      300: `${color.blue[300]}`,
      400: `${color.blue[400]}`,
      500: `${color.blue[500]}`,
      600: `${color.blue[600]}`,
      700: `${color.blue[700]}`,
      800: `${color.blue[800]}`,
      900: `${color.blue[900]}`,
      ifixit: `${color.blue.ifixit}`,
   },
   lightBlue: {
      50: `${color.lightBlue[50]}`,
      100: `${color.lightBlue[100]}`,
      200: `${color.lightBlue[200]}`,
      300: `${color.lightBlue[300]}`,
      400: `${color.lightBlue[400]}`,
      500: `${color.lightBlue[500]}`,
      600: `${color.lightBlue[600]}`,
      700: `${color.lightBlue[700]}`,
      800: `${color.lightBlue[800]}`,
      900: `${color.lightBlue[900]}`,
   },
   cyan: {
      50: `${color.cyan[50]}`,
      100: `${color.cyan[100]}`,
      200: `${color.cyan[200]}`,
      300: `${color.cyan[300]}`,
      400: `${color.cyan[400]}`,
      500: `${color.cyan[500]}`,
      600: `${color.cyan[600]}`,
      700: `${color.cyan[700]}`,
      800: `${color.cyan[800]}`,
      900: `${color.cyan[900]}`,
   },
   teal: {
      50: `${color.teal[50]}`,
      100: `${color.teal[100]}`,
      200: `${color.teal[200]}`,
      300: `${color.teal[300]}`,
      400: `${color.teal[400]}`,
      500: `${color.teal[500]}`,
      600: `${color.teal[600]}`,
      700: `${color.teal[700]}`,
      800: `${color.teal[800]}`,
      900: `${color.teal[900]}`,
   },
   emerald: {
      50: `${color.emerald[50]}`,
      100: `${color.emerald[100]}`,
      200: `${color.emerald[200]}`,
      300: `${color.emerald[300]}`,
      400: `${color.emerald[400]}`,
      500: `${color.emerald[500]}`,
      600: `${color.emerald[600]}`,
      700: `${color.emerald[700]}`,
      800: `${color.emerald[800]}`,
      900: `${color.emerald[900]}`,
   },
   green: {
      50: `${color.green[50]}`,
      100: `${color.green[100]}`,
      200: `${color.green[200]}`,
      300: `${color.green[300]}`,
      400: `${color.green[400]}`,
      500: `${color.green[500]}`,
      600: `${color.green[600]}`,
      700: `${color.green[700]}`,
      800: `${color.green[800]}`,
      900: `${color.green[900]}`,
   },
   lime: {
      50: `${color.lime[50]}`,
      100: `${color.lime[100]}`,
      200: `${color.lime[200]}`,
      300: `${color.lime[300]}`,
      400: `${color.lime[400]}`,
      500: `${color.lime[500]}`,
      600: `${color.lime[600]}`,
      700: `${color.lime[700]}`,
      800: `${color.lime[800]}`,
      900: `${color.lime[900]}`,
   },
   yellow: {
      50: `${color.yellow[50]}`,
      100: `${color.yellow[100]}`,
      200: `${color.yellow[200]}`,
      300: `${color.yellow[300]}`,
      400: `${color.yellow[400]}`,
      500: `${color.yellow[500]}`,
      600: `${color.yellow[600]}`,
      700: `${color.yellow[700]}`,
      800: `${color.yellow[800]}`,
      900: `${color.yellow[900]}`,
   },
   amber: {
      50: `${color.amber[50]}`,
      100: `${color.amber[100]}`,
      200: `${color.amber[200]}`,
      300: `${color.amber[300]}`,
      400: `${color.amber[400]}`,
      500: `${color.amber[500]}`,
      600: `${color.amber[600]}`,
      700: `${color.amber[700]}`,
      800: `${color.amber[800]}`,
      900: `${color.amber[900]}`,
   },
   orange: {
      50: `${color.orange[50]}`,
      100: `${color.orange[100]}`,
      200: `${color.orange[200]}`,
      300: `${color.orange[300]}`,
      400: `${color.orange[400]}`,
      500: `${color.orange[500]}`,
      600: `${color.orange[600]}`,
      700: `${color.orange[700]}`,
      800: `${color.orange[800]}`,
      900: `${color.orange[900]}`,
   },
   red: {
      50: `${color.red[50]}`,
      100: `${color.red[100]}`,
      200: `${color.red[200]}`,
      300: `${color.red[300]}`,
      400: `${color.red[400]}`,
      500: `${color.red[500]}`,
      600: `${color.red[600]}`,
      700: `${color.red[700]}`,
      800: `${color.red[800]}`,
      900: `${color.red[900]}`,
   },
   gray: {
      50: `${color.gray[50]}`,
      100: `${color.gray[100]}`,
      200: `${color.gray[200]}`,
      300: `${color.gray[300]}`,
      400: `${color.gray[400]}`,
      500: `${color.gray[500]}`,
      600: `${color.gray[600]}`,
      700: `${color.gray[700]}`,
      800: `${color.gray[800]}`,
      900: `${color.gray[900]}`,
   },
};
